import { render, staticRenderFns } from "./VariablesTab.vue?vue&type=template&id=4d3ca485&scoped=true"
import script from "./VariablesTab.vue?vue&type=script&lang=js"
export * from "./VariablesTab.vue?vue&type=script&lang=js"
import style0 from "./VariablesTab.vue?vue&type=style&index=0&id=4d3ca485&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3ca485",
  null
  
)

export default component.exports